module.exports = __webpack_public_path__ + "assets/media/drift_login_splash_image.54fbc1aa.png";